module.exports = __webpack_public_path__ + "static/media/pwdpolicy.b81bf45b.svg";